import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Slider, { Handle } from 'rc-slider';
import { DragIcon } from 'images/common';

import messages from 'utils/messages';
import classNames from 'classnames';
import 'rc-slider/assets/index.css';

class SingleRange extends React.Component {
  state = {
    filterValue: [0]
  }

  onChange = (value) => {
    this.setState({ filterValue: value })
    this.props.onChange && this.props.onChange(value)
  }

  render() {
    const { title, customClass, color, disabled, onFilterApply, maxValue = 0, minValue = 0, isPercent, value, showLegend, isSmall, borderColor, legendColor, step = 1, range, titleMax, unit, readOnly } = this.props;
    const getValue = value ? value : this.state.filterValue

    const customInputClass = `range-slider text-field text-field_nolabel text-field_${customClass}`;

    const inputClass = classNames({
      'text-field__range': true,
      'text-field__input': true,
      'text-field__input_filled': true,
    });

    const handleSliderClass = classNames('slider-icon', {
      [color]: color,
      disabled,
    });

    return (
      <div className={classNames(
        `text-field__range_container text-field__range_container_${customClass}`,
        (isPercent || unit) && 'text-field__range_container--percent',
        isSmall && 'text-field__range_container--small',
      )}>
        <div className='filters-bar__range_container'>
          <div>
            <div className="filters-bar__heading">{title}</div>
            <div className={classNames("filters-bar__range", borderColor && `viso-border-${borderColor}`)}>
              <input
                type="text"
                readOnly={readOnly}
                maxLength={4}
                value={range ? getValue[0] : getValue}
                className={inputClass}
                onChange={e => this.onChange(e.target.value)}
              />
              {(isPercent || unit) && <div className='filters-bar__heading filters-bar__heading--percent'>{unit || '%'}</div>}
            </div>
          </div>
          {range &&
            <div>
              <div className="filters-bar__heading">{titleMax}</div>
              <div className={classNames("filters-bar__range filters-bar__range--max", borderColor && `viso-border-${borderColor}`)}>
                <input
                  type="text"
                readOnly={readOnly}
                  maxLength={4}
                  value={range ? getValue[1] : getValue}
                  className={inputClass}
                  onChange={e => this.onChange(e.target.value)}
                />
                {(isPercent || unit) && <div className='filters-bar__heading filters-bar__heading--percent'>{unit || '%'}</div>}
              </div>
            </div>
          }
        </div>
        <div className={customInputClass}>
          <Slider
            handle={handleProps => (
              <Handle {...handleProps}>
                <div className={handleSliderClass}><DragIcon /></div>
              </Handle>
            )}
            onChange={val => this.onChange(val)}
            min={minValue}
            max={maxValue}
            value={range ? getValue : [getValue]}
            defaultValue={range ? getValue : [getValue]}
            step={step}
            allowCross={false}
            range={range}
          />
        </div>
        {showLegend &&
          <div className={classNames('rc-slider-legend', legendColor && `viso-text-${legendColor}`)}>
            <div className='rc-slider-legend__item rc-slider-legend__item--min'>{minValue}{unit || (isPercent && '%')}</div>
            <div className='rc-slider-legend__item rc-slider-legend__item--max'>{maxValue}{unit || (isPercent && '%')}</div>
          </div>
        }
        {onFilterApply &&
          <>
            <hr className="mt_100" />
            <button type="button" className={`filters-bar__apply ${customClass}`} onClick={onFilterApply}>
              <FormattedMessage {...messages.apply} />
            </button>
          </>
        }
      </div>
    );
  }
}

SingleRange.propTypes = {
  name: PropTypes.string,
  isPercent: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onFilterApply: PropTypes.func,
  onChange: PropTypes.func,
  customClass: PropTypes.string,
};

export default SingleRange;
